import type { RouteLocationNormalized } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"

/**
 * Cible de redirection pour la route racine `/` selon le plan d'abonnement entreprise.
 * EM → dashboard Energy Manager, EA → dossiers, sinon → liste des bâtiments.
 */
export async function getHomeRedirectTarget(
    to: RouteLocationNormalized
): Promise<{ path: string; query: RouteLocationNormalized["query"] } | null> {
    const authStore = useAuthStore()
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
    // Plan dérivé de la liste brute des abonnements Stripe, pas du champ
    // dénormalisé `operation.stripe.plan` qui peut rester figé (DEV-1327).
    const plan = authStore.subscriptionPlan
    const query = to.query
    if (plan === "EM") {
        return { path: "/energy-manager/dashboard", query }
    }
    if (plan === "EA") {
        return { path: "/folder", query }
    }
    return { path: "/building", query }
}
